export function canvasWidth(spec) {
  return Number((spec.canvas || {}).width) || 1200;
}

export function canvasHeight(spec) {
  const bottoms = (spec.placements || []).map((p) => p.layout.y + p.layout.h);
  return Math.max(240, ...bottoms) + 24;
}

export function filterDefaults(spec) {
  const values = {};
  (spec.filters || []).forEach((f) => { values[f.name] = f.default ?? ''; });
  return values;
}

export function placeStyle(p) {
  return {
    left: p.layout.x + 'px', top: p.layout.y + 'px',
    width: p.layout.w + 'px', height: p.layout.h + 'px',
    zIndex: p.layout.z || 1,
  };
}

export function stageStyle(spec) {
  const canvas = spec.canvas || {};
  return {
    background: canvas.background || 'transparent',
    padding: (Number(canvas.padding) || 0) + 'px',
  };
}

export function pageScope(spec, placement, host, filters, local) {
  const declared = Object.keys(spec.implicit || {});
  const pageFilters = (spec.filters || []).map((f) => f.name);
  const ownFilters = (placement.filters || []).map((f) => f.name);
  const filled = (v) => v !== null && v !== undefined && v !== '';
  const scope = {};
  Object.entries(spec.implicit || {}).forEach(([k, v]) => { if (v !== null) scope[k] = v; });
  Object.entries(host || {}).forEach(([k, v]) => { if (declared.includes(k) && filled(v)) scope[k] = v; });
  Object.entries(filters || {}).forEach(([k, v]) => { if (pageFilters.includes(k) && filled(v)) scope[k] = v; });
  Object.entries(placement.implicit || {}).forEach(([k, v]) => { if (v !== null) scope[k] = v; });
  Object.entries(local || {}).forEach(([k, v]) => { if (ownFilters.includes(k) && filled(v)) scope[k] = v; });
  return scope;
}

export function localDefaults(placement) {
  const values = {};
  (placement.filters || []).forEach((f) => { values[f.name] = f.default ?? ''; });
  return values;
}
